import { useParams } from 'react-router-dom';

import { Navigate } from '~/components/utils/Navigation';

export const AppRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={`/apps/${appId}/onboarding`} replace />;
};
